import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { Card, Button, Form, Input, Row, Col, Alert, Spin } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";

import { login } from "src/redux/actions/auth";
import { clearMessage } from "src/redux/actions/message";
import useForm from "src/hooks/useForm";
import swal from "sweetalert";

const App = () => {
  let navigate = useNavigate();
  const location = useLocation();

  const SITE_KEY = "6LeH8XwhAAAAALw43tTI0iPcLqx8vrlMvkyRwuB6";

  // Create a new URLSearchParams object from the location.search string
  const queryParams = new URLSearchParams(location.search);

  // Get the 'd' parameter value
  const page = queryParams.get("page");

  const [loading, setLoading] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearMessage());

    //console.log(SITE_KEY);
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL(
      "recaptcha-key",
      `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`,
      function () {
        console.log("Script loaded!");
      }
    );
  }, []);

  if (isLoggedIn) {
    if (!page) return <Navigate to="/" />;
  }

  const onFinish = (values) => {
    setLoading(true);
    if (!loading) {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(SITE_KEY, { action: "submit" })
          .then((token) => {
            dispatch(login(values.email, values.password, token))
              .then(() => {
                swal("Success", "success", "success", {
                  buttons: false,
                  timer: 2000,
                });
                window.setTimeout(() => {
                  //setSuccess(true);
                  setLoading(false);
                  if (page) navigate(page);
                  else navigate("/");
                  //window.location.reload();
                }, 2000);
              })
              .catch(() => {
                setLoading(false);
              });
          });
      });
    }
  };

  return (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      <Col>
        <Card title="Login" style={{ width: 400 }}>
          <Form
            name="login_form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Tolong masukkan email Anda!" },
                {
                  type: "email",
                  message: "Format email tidak valid!",
                },
              ]}
            >
              <Input
                placeholder="Email"
                prefix={<MailOutlined />}
                size="large"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Tolong masukkan password Anda!" },
              ]}
            >
              <Input.Password
                placeholder="Password"
                prefix={<LockOutlined />}
                size="large"
              />
            </Form.Item>
            {!loading && message && (
              <Alert
                message={message}
                type="error"
                showIcon
                style={{ marginBottom: "16px" }}
              />
            )}
            <Form.Item>
              <Spin spinning={loading} delay={100}>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  shape="round"
                >
                  Login
                </Button>
              </Spin>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};
export default App;
